import React from 'react'
import {Col, Descriptions, Divider, Row} from "antd";
import userDateFormatter from "../../../services/formatters/userDateFormatter";
import {Table} from "react-bootstrap";

class RecipeDetailedItems extends React.Component {
    render() {
        return (
            <React.Fragment>
                <div>
                    <Row>
                        <Col span={24}>
                            <h3>Reçete Özeti</h3>
                            <Divider/>
                            <Descriptions
                                bordered
                            >
                                <Descriptions.Item
                                    label={'Reçete Adı'}>{this.props.recipe.recipe.name}</Descriptions.Item>
                                {/*<Descriptions.Item*/}
                                {/*    label={'Reçete Kodu'}>{this.props.recipe.recipe.code}</Descriptions.Item>*/}
                                {/*<Descriptions.Item*/}
                                {/*    label={'Reçete Tutarı'}>{`${this.props.recipe.recipe.price.toFixed(2)} TL`}</Descriptions.Item>*/}
                                <Descriptions.Item
                                    label={'Reçete Açıklaması'}>{this.props.recipe.recipe.description}</Descriptions.Item>
                                <Descriptions.Item
                                    label={'Reçeteyi Oluşturan'}>{this.props.recipe.recipe.createdBy}</Descriptions.Item>
                                <Descriptions.Item
                                    label={'Oluşturulma Tarihi'}>{userDateFormatter(this.props.recipe.recipe.createdDate)}</Descriptions.Item>
                            </Descriptions>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24}>
                            <h3 style={{marginTop: '16px'}}>Reçete Malzeme Listesi</h3>
                            <Divider/>
                            <Table
                                responsive
                            >
                                <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Stok Açıklaması</th>
                                    <th>Miktar</th>
                                    <th>Birim</th>
                                    {/*<th>Birim Fiyat</th>*/}
                                    {/*<th>Kur</th>*/}
                                    {/*<th>Parite</th>*/}
                                    {/*<th>Toplam</th>*/}
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    this.props.recipe.billOfMaterials.map((item, index) => {
                                        return (
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>{item.stock.description}</td>
                                                <td>{item.amount}</td>
                                                <td>{item.stock.unit}</td>
                                                {/*<td>{item.stock.price}</td>*/}
                                                {/*<td>{item.stock.currency}</td>*/}
                                                {/*<td>{item.parity}</td>*/}
                                                {/*<td>{`${(item.lineTotal).toFixed(2)} TL`}</td>*/}
                                            </tr>
                                        )
                                    })
                                }
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                    {/*<Row>*/}
                    {/*    <Col span={24}>*/}
                    {/*        <h3 style={{marginTop: '16px'}}>Üretim Giderleri Listesi</h3>*/}
                    {/*        <Divider/>*/}
                    {/*        <Table*/}
                    {/*            responsive*/}
                    {/*        >*/}
                    {/*            <thead>*/}
                    {/*            <tr>*/}
                    {/*                <th>#</th>*/}
                    {/*                <th>Gider Adı</th>*/}
                    {/*                <th>Oran(%)</th>*/}
                    {/*                <th>Toplam</th>*/}
                    {/*            </tr>*/}
                    {/*            </thead>*/}
                    {/*            <tbody>*/}
                    {/*            {*/}
                    {/*                this.props.recipe.recipeProductionCosts.map((item, index) => {*/}
                    {/*                    return (*/}
                    {/*                        <tr key={index}>*/}
                    {/*                            <td>{index + 1}</td>*/}
                    {/*                            <td>{item.costName}</td>*/}
                    {/*                            <td>{item.ratio}</td>*/}
                    {/*                            <td>{`${(item.lineTotal).toFixed(2)} TL`}</td>*/}
                    {/*                        </tr>*/}
                    {/*                    )*/}
                    {/*                })*/}
                    {/*            }*/}
                    {/*            </tbody>*/}
                    {/*        </Table>*/}
                    {/*    </Col>*/}
                    {/*</Row>*/}
                </div>
            </React.Fragment>
        );
    }
}

export default RecipeDetailedItems